import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import getAltFromSrc from 'commons/getAltFromSrc';
import JBImage from 'components/essentials/JBImage';
import Placeholder from 'components/consumer/Placeholder';
import VisuallyHidden from 'components/consumer/VisuallyHidden';
import Prefetcher from '../../../../essentials/Prefetcher/index';
import { getMainImageImgixPropsForPhoto, getThumbnailImageImgixPropsForPhoto } from '../helpers/imgix-props';
import usePDPDesktopHeroSizeProps from '../helpers/usePDPDesktopHeroSizeProps';
import { PDP_GALLERY_THUMBNAIL_IMAGE } from '../specs/testIds';
const PDPDesktopHeroThumbnail = t0 => {
  const $ = _c(40);
  const {
    ariaLabel,
    ariaPressed,
    children,
    cropData,
    enableCrops,
    icon,
    iconCenter: t1,
    loading: t2,
    isSelected: t3,
    onClick: t4,
    onLoadFailure: t5,
    onMouseEnter: t6,
    src,
    title,
    type: t7,
    isConfigFlipped: t8,
    isCylindoPhoto: t9,
    iconClass: t10
  } = t0;
  const iconCenter = t1 === undefined ? false : t1;
  const loading = t2 === undefined ? false : t2;
  const isSelected = t3 === undefined ? false : t3;
  const onClick = t4 === undefined ? _temp : t4;
  const onLoadFailure = t5 === undefined ? _temp2 : t5;
  const onMouseEnter = t6 === undefined ? _temp3 : t6;
  const type = t7 === undefined ? "studio" : t7;
  const isConfigFlipped = t8 === undefined ? false : t8;
  const isCylindoPhoto = t9 === undefined ? false : t9;
  const iconClass = t10 === undefined ? "" : t10;
  const [isError, setIsError] = useState(false);
  const mainPhotoSizeProps = usePDPDesktopHeroSizeProps();
  if (!(loading || src || children || icon) || isError) {
    return null;
  }
  const t11 = !isSelected;
  let t12;
  if ($[0] !== isSelected || $[1] !== loading || $[2] !== t11) {
    t12 = classNames("items-stretch border border-solid rounded bg-white flex justify-between h-[38px] overflow-hidden w-11 lg:max-[1100px]:h-[33px] lg:max-[1100px]:w-[39px] [&+&]:ml-1", "hover:cursor-pointer hover:border-brand-dark", "focus-visible:outline-brand", {
      "hover:cursor-default hover:border-gray-light8": loading,
      "border-gray-light7": t11,
      "border-brand-dark": isSelected
    });
    $[0] = isSelected;
    $[1] = loading;
    $[2] = t11;
    $[3] = t12;
  } else {
    t12 = $[3];
  }
  const t13 = (type === "configuration" || type === "cylindo") && isConfigFlipped;
  let t14;
  if ($[4] !== t13) {
    t14 = classNames("relative items-center flex justify-center h-full w-full", {
      "scale-x-[-1]": t13
    });
    $[4] = t13;
    $[5] = t14;
  } else {
    t14 = $[5];
  }
  let t15;
  if ($[6] !== cropData || $[7] !== enableCrops || $[8] !== isCylindoPhoto || $[9] !== mainPhotoSizeProps || $[10] !== onLoadFailure || $[11] !== src || $[12] !== type) {
    t15 = !!src && <Prefetcher onRenderAssets={[{
      url: src,
      imgixProps: !isCylindoPhoto ? {
        ...getMainImageImgixPropsForPhoto({
          src,
          type,
          cropData
        }, enableCrops),
        ...mainPhotoSizeProps
      } : null,
      isProductImage: true
    }]} className="block h-full !w-full">{isCylindoPhoto ? <img className="h-full" data-testid={PDP_GALLERY_THUMBNAIL_IMAGE} src={src} width={44} height={38} alt={getAltFromSrc(src)} /> : <JBImage className={classNames("flex-1", {
        "object-none h-[38px] w-11": type === "configuration" || type === "cylindo",
        "h-full object-cover w-full": type === "studio"
      })} data-testid={PDP_GALLERY_THUMBNAIL_IMAGE} forPage="pdp" lazy={false} onLoad={isFail => {
        if (!isFail) {
          return;
        }
        setIsError(true);
        onLoadFailure();
      }} {...getThumbnailImageImgixPropsForPhoto({
        src,
        type
      })} />}</Prefetcher>;
    $[6] = cropData;
    $[7] = enableCrops;
    $[8] = isCylindoPhoto;
    $[9] = mainPhotoSizeProps;
    $[10] = onLoadFailure;
    $[11] = src;
    $[12] = type;
    $[13] = t15;
  } else {
    t15 = $[13];
  }
  let t16;
  if ($[14] !== children) {
    t16 = !!children && <div className="text-xs font-bold text-gray">{children}</div>;
    $[14] = children;
    $[15] = t16;
  } else {
    t16 = $[15];
  }
  let t17;
  if ($[16] !== icon || $[17] !== iconCenter || $[18] !== iconClass) {
    t17 = !!icon && <div className={classNames(`items-center flex justify-center [&_svg]:p-[5px] ${iconClass}`, {
      absolute: iconCenter
    })}>{icon}</div>;
    $[16] = icon;
    $[17] = iconCenter;
    $[18] = iconClass;
    $[19] = t17;
  } else {
    t17 = $[19];
  }
  let t18;
  if ($[20] !== t14 || $[21] !== t15 || $[22] !== t16 || $[23] !== t17) {
    t18 = <div className={t14}>{t15}{t16}{t17}</div>;
    $[20] = t14;
    $[21] = t15;
    $[22] = t16;
    $[23] = t17;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== loading || $[26] !== t18) {
    t19 = <Placeholder loading={loading} type="rect" className="!mr-0">{t18}</Placeholder>;
    $[25] = loading;
    $[26] = t18;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== ariaPressed || $[29] !== isSelected) {
    t20 = !!isSelected && ariaPressed === undefined && <VisuallyHidden>- selected</VisuallyHidden>;
    $[28] = ariaPressed;
    $[29] = isSelected;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] !== ariaLabel || $[32] !== ariaPressed || $[33] !== onClick || $[34] !== onMouseEnter || $[35] !== t12 || $[36] !== t19 || $[37] !== t20 || $[38] !== title) {
    t21 = <button aria-label={ariaLabel} aria-pressed={ariaPressed} title={title} className={t12} onClick={onClick} onMouseEnter={onMouseEnter} type="button">{t19}{t20}</button>;
    $[31] = ariaLabel;
    $[32] = ariaPressed;
    $[33] = onClick;
    $[34] = onMouseEnter;
    $[35] = t12;
    $[36] = t19;
    $[37] = t20;
    $[38] = title;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  return t21;
};
PDPDesktopHeroThumbnail.propTypes = {
  ariaLabel: PropTypes.string,
  ariaPressed: PropTypes.bool,
  children: PropTypes.node,
  cropData: PropTypes.object,
  enableCrops: PropTypes.bool,
  icon: PropTypes.node,
  iconCenter: PropTypes.bool,
  iconClass: PropTypes.string,
  isConfigFlipped: PropTypes.bool,
  isCylindoPhoto: PropTypes.bool,
  isSelected: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  onLoadFailure: PropTypes.func,
  onMouseEnter: PropTypes.func,
  src: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.oneOf(['buildyourown', 'configuration', 'cylindo', 'dimensional', 'open-close', 'studio'])
};
export default PDPDesktopHeroThumbnail;
function _temp() {}
function _temp2() {}
function _temp3() {}